import { SubmissionError } from 'redux-form';

// Helper that throws redux form errors.
export default errors => {
  if (errors && errors.length > 0) {
    errors.forEach(({ field, message }) => {
      throw new SubmissionError({
        ...field && { [field]: message },
        ...!field && { _error: message },
      });
    });
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/helpers/throwErrors.js